<template>
    <div class="m-corp">
        <h5 class="title"></h5>

        <div class="corp-info">
            <div class="personal">你的军团：{{ $store.state.teamdata.corpName || '----' }}</div>
            <div class="team">组队人数：{{ $store.state.teamdata.corpName && $store.state.teamdata.teamUv || 0 }}</div>
        </div>

        <div class="task-view">
            <div class="task-item" v-for="(item,index) in task_config" :key="index">
                <h6 class="corp-title" :class="'t-' + (index + 1)"></h6>
                <div class="task-detail">
                    <div class="reward-list">
                        <ul :class="'r-' + (index + 1)">
                            <li v-for="(r,k) in item.gift" :key="k" class="game-item">
                                <div class="pack-icon" v-tips="r.id">
                                    <game-item :id="r.id" :num="r.num" :locked="true"></game-item>
                                </div>                                
                            </li>
                        </ul>
                    </div>

                    <div class="u-btn apply" :class="{'disabled' : $store.state.teamdata.teamUv < 20 || $store.state.team.length < 5 || $store.state.teamdata.corpBoon == 0 , 'dismiss' : $store.state.teamdata.corpBoon == 9}" @click="apply(item.apply_url,item.per,item)" v-if="item.type == 'task'"></div>
                    <div class="u-btn buy" :class="{'disabled' : $store.state.teamdata.teamUv < 20 || $store.state.team.length < 5 || $store.state.teamdata.corpBuy == 0 , 'dismiss' : $store.state.teamdata.corpBuy == 9}" @click="buy()" v-if="item.type == 'buy'"></div>
                </div>
            </div>

        </div>

        <p class="notice">温馨提示：领取与购买时你必须处于5人组队状态。</p>
    </div>
</template>

<style lang="scss" scoped>
.m-corp{
    @media screen and (min-width: 900px) {
        .title{
            width: 803px;
            height: 95px;
            margin: 0 auto 25px;
            background-image: url(~@/assets/images/pc/title-3.png);
        }
        
        .corp-info{
            display: flex;
            justify-content: center;
            margin-bottom: 17px;
            font-size: 20px;
            color: #af6328;

            div{
                margin: 0 28px;
            }
        }

        .task-view{
            position: relative;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 1287px;
            margin: 0 auto 26px;
            
            .task-item{
                position: relative;
                width: 628px;
                height: 373px;
                padding-top: 30px;
                box-sizing: border-box;                    
                background-image: url(~@/assets/images/pc/bg-team_gift_item.png);
                
                .u-btn{
                    position: absolute;
                    bottom: 32px;
                    left: 50%;
                    width: 222px;
                    height: 66px;
                    margin-left: -111px;
                    background-image: url(~@/assets/images/pc/btn-apply_corp.png);

                    &.apply.dismiss{
                        background-image: url(~@/assets/images/pc/btn-apply_dismiss.png);
                    }
                    
                    &.apply.disabled{
                        background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                    }                         

                    &.buy{
                        background-image: url(~@/assets/images/pc/btn-buy_corp.png);

                        &.dismiss,&.disabled{
                            background-image: url(~@/assets/images/pc/btn-buy_corp_disabled.png);
                        }                           
                    }
                }                
            }

            .corp-title{
                width: 100%;
                height: 65px;
                margin-bottom: 35px;
                background-repeat: no-repeat;
                background-position: center top;
               
                @for $i from 1 through 2{
                    &.t-#{$i}{
                        background-image: url(~@/assets/images/pc/title-corp_#{$i}.png);   
                    }
                }             
            }
        }

        .reward-list{
            ul{
                display: flex;
                justify-content: space-between;

                &.r-1{
                    padding: 0 42px;
                }

                &.r-2{
                    padding: 0 27px;
                }                
            }
        }
        
        .game-item{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 104px;
            height: 105px;
            margin: 0 auto;
            background-image: url(~@/assets/images/pc/bg-item.png);

            .pack-icon{
                width: 46px;
                height: 46px;
            }
        }        

        .notice{
            text-align: center;
            color: #ab664e;
            font-size: 18px;
        }
    }

    @media screen and (max-width: 899px) {
        .title{
            width: 744px;
            height: 106px;
            margin: 0 auto 25px;
            background-image: url(~@/assets/images/m/title-3.png);
        }
        
        .corp-info{
            display: flex;
            justify-content: center;
            margin-bottom: 17px;
            font-size: 24px;
            color: #af6328;

            div{
                margin: 0 28px;
            }
        }

        .task-view{
            position: relative;
            margin: 0 auto 26px;
            
            .task-item{
                position: relative;
                width: 628px;
                height: 373px;
                padding-top: 30px;
                margin: 0 auto 20px;
                box-sizing: border-box;                    
                background-image: url(~@/assets/images/pc/bg-team_gift_item.png);
                
                .u-btn{
                    position: absolute;
                    bottom: 32px;
                    left: 50%;
                    width: 222px;
                    height: 66px;
                    margin-left: -111px;
                    background-image: url(~@/assets/images/pc/btn-apply_corp.png);

                    &.apply.dismiss{
                        background-image: url(~@/assets/images/pc/btn-apply_dismiss.png);
                    }
                    
                    &.apply.disabled{
                        background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                    }                      

                    &.buy{
                        background-image: url(~@/assets/images/pc/btn-buy_corp.png);

                        &.dismiss,&.disabled{
                            background-image: url(~@/assets/images/pc/btn-buy_corp_disabled.png);
                        }                         
                    }
                }                
            }

            .corp-title{
                width: 100%;
                height: 65px;
                margin-bottom: 35px;
                background-repeat: no-repeat;
                background-position: center top;
               
                @for $i from 1 through 2{
                    &.t-#{$i}{
                        background-image: url(~@/assets/images/pc/title-corp_#{$i}.png);   
                    }
                }             
            }
        }

        .reward-list{
            ul{
                display: flex;
                justify-content: space-between;

                &.r-1{
                    padding: 0 42px;
                }

                &.r-2{
                    padding: 0 27px;
                }                
            }
        }
        
        .game-item{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 104px;
            height: 105px;
            margin: 0 auto;
            background-image: url(~@/assets/images/pc/bg-item.png);

            .pack-icon{
                width: 46px;
                height: 46px;
            }
        }        

        .notice{
            text-align: center;
            color: #ab664e;
            font-size: 18px;
        }        
    }
}
</style>


<script>
export default {
    data (){
        return {
            task_config : [
                {
                    task : '军团齐心礼',
                    max: 1,
                    token : 10,
                    per : 10,
                    type : 'task',
                    apply_url : ajax_url_map.corp_gift,
                    flag : this.$store.state.teamdata.corpBoon,
                    gift :  [{id : 'KW99',name : '',num : 5},{id : 'KV27',name : '',num : 50},{id : 'E548',name : '',num : 1},{ id : 'E553',name : '',num : 1 }],
                },
                {
                    task : '军团内购礼',
                    max: 5,
                    token : 5,
                    per : 1,
                    type : 'buy',
                    apply_url : ajax_url_map.corp_pack,
                    flag : this.$store.state.teamdata.corpBuy,
                    gift :  [{id : 'D355',name : '',num : 2},{id : 'KW99',name : '',num : 10},{id : 'E246',name : '',num : 1},{ id : 'X567',name : '',num : 5 },{ id : 'X472',name : '',num : 10 }],
                },                                                
            ],
            tokeninfo : ()=>{},
            my_token : 0,
            team_token : 0,
            ready : false,
            ready_1 : false,
            ready_2 : false,
        }
    },
    created (){
        let vm = this;
    },
    methods : {   
        init (){

        },    
        apply (url,val,item){
            let _this = this;

            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();
            
            this.$axios.get(url)
            .then(
                res => {
                    this.$msg_modal({'text' : '领取成功'});
                    var add = item.max == 1 ? (val * item.max) : (val * item.cnt);
                    //console.log(val * item.cnt);
                    //this.toekn_update(add);
                    //item.cnt = Math.min( (item.cnt + 1) , item.max );
                    this.$update_team();
                },
                rej => {
                    this.$toast(rej.message);
                }
            )
        },
        apply_pack (url,flag){
            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();
            
            this.$axios.get(url)
            .then(
                res => {
                    this.$msg_modal({'text' : '领取成功'});
                    flag = true;
                },
                rej => {
                    this.$toast(rej.message);
                }
            )
        },
        buy(){
            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();

            if(this.$store.state.teamdata.teamUv < 20 || !this.$store.state.teamdata.teamUv)return this.$toast('不符合购买条件哟，请刷新页面后重试!~');

            this.$comfirm_buy({type : 2});            
        },      
        error_disabled (){
            this.$toast('当前不符合领奖条件哦~')
        },
        error_dismiss(){
            this.$toast('已领取过奖励了哦~')
        },
        toekn_update (val){
            this.my_token += val,
            this.$store.commit("$_setCurrency", this.my_token);
        },        
    },
}
</script>


// WEBPACK FOOTER //
// src/components/views/corp.vue